<template>
  <div>
    <div class="weui-form__text-area">
      <h2 class="weui-form__title" style="text-align: center; padding: 1rem">
        {{ this.$route.params.nodeName }}{{ $t("apps.title") }}
      </h2>
    </div>
    <div v-if="this.$store.state.apps.length">
      <ul>
        <li v-for="(app, index) in this.$store.state.apps" :key="`client-${index}`">
          <app-card :data="app" :index="index"></app-card>
        </li>
      </ul>
    </div>
    <div v-else class="has-text-centered" style="color: #aaa; margin-top: calc(134px + 2rem)">
      <span style="
          background: #eeeff7;
          padding: 0 0.8rem;
          position: relative;
          z-index: 2;
        ">{{ requestText }}</span>
      <div style="position: relative; top: -0.5rem; margin: 0 1rem; z-index: 1"></div>
      <!-- <a class="weui-uploader__input-box" id="list_note_icon"></a> -->
    </div>
    <a class="add-btn" @click="
      this.$router.push({
        path: '/appedit/' + encodeURIComponent(this.$route.params.nodeName),
      })
      " :title="btnTitle">
      <feather-plus></feather-plus>
      <span v-if="this.$store.state.apps.length < 1" class="weui-badge weui-badge_dot"
        style="position: relative; top: -56px; right: -28px"></span>
    </a>
  </div>
</template>

<script>
import axios from "axios"
import AppCard from "./card/appcard.vue"

export default {
  name: "p2papp",
  components: {
    AppCard,
  },

  data() {
    return {
      apps: [],
      requestState: "requesting",
      popupState: {
        display: false,
        data: {},
        isLoading: false,
      },
    }
  },

  beforeMount() { },

  mounted() {
    this.loadApps()
    window.debugLog("p2papp " + this.$route.params.nodeName)
  },
  computed: {
    btnTitle() {
      return this.$t("apps.new")
    },
    requestText() {
      window.debugLog("requestText", this.requestState)
      if (this.requestState == "timeout") {
        return this.$t("requestTimeout")
      } else if (this.requestState == "end") {
        return this.$t("apps.noApp")
      }
      return this.$t("requesting")
    },
  },
  methods: {
    // handleCardEvent: function () {
    //   window.debugLog("recv child's msg")
    //   this.loadApps()
    // },
    loadApps: async function () {
      // TODO: support both debug and release url
      this.$store.commit("setApps", {}) // clear first
      this.requestState = "requesting"
      try {
        await this.$initDataOnce()
        let res = await axios.get(
          this.$ServerHost +
          "/api/v1/device/" +
          encodeURIComponent(this.$route.params.nodeName) +
          "/apps"
        )
        window.debugLog("apps:", res)
        if (res && res.data.Apps) {
          let _apps = res.data.Apps
          this.apps = _apps.map((app) => {
            let {
              srcPort,
              protocol,
              peerNode,
              peerUser,
              appName,
              dstHost,
              dstPort,
              whitelist,
              peerIP,
              peerNatType,
              relayNode,
              specRelayNode,
              relayMode,
              linkMode,
              isActive,
              enabled,
              connectTime,
              error,
            } = app
            // window.debugLog("got one app", app)
            return {
              error,
              srcPort,
              protocol,
              appName,
              relayNode,
              specRelayNode,
              relayMode,
              linkMode,
              peerNode,
              peerUser,
              dstHost,
              dstPort,
              whitelist,
              peerIP,
              peerNatType,
              isActive,
              enabled,
              nodeName: this.$route.params.nodeName,
              connectTime: new Date(connectTime).format("yyyy-MM-dd hh:mm:ss"),
            }
          })
          this.$store.commit("setApps", this.apps)
        }
        this.requestState = "end"
        window.debugLog("get apps:", this.apps)
      } catch (err) {
        this.requestState = "timeout"
      }
    },
  },

  watch: {},
}
</script>




